module.exports = __webpack_public_path__ + "img/photo-3.47da765a.jpg";